"use client";

import { ErrorPage } from "@ala/core/components/error-page";

const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  return <ErrorPage error={error} reset={reset} />;
};

export default GlobalError;
